module.exports = __webpack_public_path__ + "46b19aa9b98b0ef48c79e647016ab886.svg";